import { CalendarSidebar } from "./calendar/components/CalendarSidebar.js";
import { CalendarPage } from "./calendar/pages/CalendarPage.js";
import { ChatSidebar } from "./chat/components/ChatSidebar.js";
import { ChatPage } from "./chat/pages/ChatPage.js";
import { FilesSidebar } from "./files/components/FilesSidebar.js";
import { FilesPage } from "./files/pages/FilesPage.js";
import { MailSidebar } from "./mail/components/MailSidebar.js";
import { MailPage } from "./mail/pages/MailPage.js";
import { PasswordsSidebar } from "./passwords/components/PasswordsSidebar.js";
import { PasswordsPage } from "./passwords/pages/PasswordsPage.js";
import { TasksSidebar } from "./tasks/components/TasksSidebar.js";
import { TasksPage } from "./tasks/pages/TasksPage.js";
import { WikiSidebar } from "./wiki/components/WikiSidebar.js";
import { WikiPage } from "./wiki/pages/WikiPage.js";
import type { FrontendModule } from "./ModuleDefinition.js";

/**
 * Alle Fach-Module der Oberfläche. Ein neues Modul wird hier eingetragen und sonst
 * nirgends — das Routing in App.tsx liest ausschließlich diese Liste.
 *
 * Jedes Modul bringt seine eigene Sidebar mit; die Shell stellt sie zwischen
 * Bereichsleiste und Inhalt. Wo Sidebar und Inhalt dieselbe Auswahl brauchen, steht sie
 * in der Adresse — als Pfad, wenn es eine eigene Ressource ist (`/chat/<id>`), sonst als
 * Suchparameter (`?tab=`, `?week=`).
 */
export const MODULES: readonly FrontendModule[] = [
  {
    id: "mail",
    route: "/mail",
    detailRoute: ":messageId",
    title: "Mail",
    page: MailPage,
    sidebar: MailSidebar,
    mobileStart: "content",
  },
  { id: "files", route: "/files", title: "Dateien", page: FilesPage, sidebar: FilesSidebar },
  {
    id: "calendar",
    route: "/calendar",
    title: "Kalender",
    page: CalendarPage,
    sidebar: CalendarSidebar,
    // Die Sidebar zeigt Zeitraum und Kalenderauswahl, kein Verzeichnis: wer den
    // Kalender öffnet, soll den Kalender sehen.
    mobileStart: "content",
  },
  {
    id: "chat",
    route: "/chat",
    // Eine Unterhaltung ist eine eigene Ressource und steht deshalb im Pfad.
    detailRoute: ":channelId",
    title: "Chat",
    page: ChatPage,
    sidebar: ChatSidebar,
  },
  {
    id: "tasks",
    route: "/tasks",
    detailRoute: ":projectId/*",
    title: "Aufgaben",
    page: TasksPage,
    sidebar: TasksSidebar,
  },
  {
    id: "wiki",
    route: "/wiki",
    detailRoute: ":pageId",
    title: "Wiki",
    page: WikiPage,
    sidebar: WikiSidebar,
  },
  {
    id: "passwords",
    route: "/passwords",
    detailRoute: ":workspaceId/:entryId?",
    title: "Passwörter",
    page: PasswordsPage,
    sidebar: PasswordsSidebar,
  },
];

export type { FrontendModule, ModulePageProps } from "./ModuleDefinition.js";
